import {
  Breakpoints,
  Carousel,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';

import { CARD_CAROUSEL_BREAKPOINTS } from '../../utils/carousel';

import ArticleCard, {
  ARTICLE_CARD_ARTICLE_PROJECTION,
  type ArticleCardArticle,
} from './ArticleCard';

export const RELATED_ARTICLES_ARTICLE_PROJECTION =
  ARTICLE_CARD_ARTICLE_PROJECTION;
interface RelatedArticlesProps {
  articles: ArticleCardArticle[];
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ articles }) => {
  const isMd = useMediaQuery(Breakpoints.MD);

  return (
    <Carousel
      swiperProps={{
        wrapperClass: 'mt-7 items-start',
        slidesPerGroupAuto: true,
        slidesPerView: 2,
        spaceBetween: 12,
        breakpoints: CARD_CAROUSEL_BREAKPOINTS,
      }}
      title={`${isMd ? 'Browse ' : ''}Related Articles`}
      items={articles.map((article) =>
        article.slug ? (
          <ArticleCard
            key={article._id}
            className={`mb-3 w-full`}
            article={article}
          />
        ) : null,
      )}
    />
  );
};

export default RelatedArticles;
